export default function radioService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};

    const eRadio = engineApi.field.setCommonAttributes('ec-radio', viewField, engineApi).addAttribute('horizontal', viewField.metadata.inline || 'true');

    // creamos los hijos <option data-value="KEY">TEXTO</option>
    if (viewField.metadata.options) {
      viewField.metadata.options.forEach(value => {
        if (value.value !== '') {
          const option = new engineApi.Element('option').addAttribute('value', value.value).setHtml(value.text);
          eRadio.appendChild(option);
        }
      });
    } else if (viewField.metadata.select) {
      // Select is deprecated
      Object.keys(viewField.metadata.select).forEach(value => {
        const option = new engineApi.Element('option').addAttribute('value', value).setHtml(viewField.metadata.select[value]);
        eRadio.appendChild(option);
      });
    }

    return eRadio;
  };
}
